export function getTranslate(transform: Transform | null): string | undefined {
  if (!transform) {
    return
  }

  const { y } = transform
  const dc = y ? Math.round(y) : 0

  return `translate3d(${0}px, ${dc}px, 0)`
}

export type Transform = {
  x: number
  y: number
  scaleX: number
  scaleY: number
}
